/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PodInfo = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        status: {
            type: 'PodPhase',
            isRequired: true,
        },
        ip: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'ipvanyaddress',
            }, {
                type: 'null',
            }],
        },
        node: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        created: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date-time',
            }, {
                type: 'null',
            }],
        },
        containers: {
            type: 'array',
            contains: {
                type: 'ContainerInfo',
            },
        },
    },
} as const;
